import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useLedgerApi } from './api';

interface TransferToCauseRequest {
  amount: number;
  causeId: string;
}

interface TransferToCauseResponse {
  amount: number;
  status: string;
  provider_id: string;
  owner_id: string;
  owner_type: string;
  payload: {
    performed_by_user_id: string;
    request_id: string;
  };
  timestamp: string;
  title: string;
  subtitle: string;
  type: string;
  transfer_to_id: string;
  transfer_to_type: string;
  on_behalf_of_id: string;
  on_behalf_of_type: string;
  uuid: string;
  created_at: string;
  updated_at: string;
  image: string;
  performed_by_user_id: string;
}

export const useTransferToCause = () => {
  const LedgerApi = useLedgerApi();
  const queryClient = useQueryClient();

  const transferToCause = async ({
    amount,
    causeId,
  }: TransferToCauseRequest): Promise<TransferToCauseResponse> => {
    const { data } = await LedgerApi.post<TransferToCauseResponse>('/transfers', {
      entry: {
        /**
         * We want to transfer the amount to the cause, so we need to make it negative
         */
        amount: -amount,
        payload: {
          to_owner_id: causeId,
          to_owner_type: 'Cause',
        },
      },
    });

    return data;
  };

  return useMutation({
    mutationFn: transferToCause,
    onSuccess: (_, variables) => {
      const { causeId } = variables;

      return Promise.all([
        queryClient.invalidateQueries({ queryKey: ['cause', causeId, 'donations'] }),
        queryClient.invalidateQueries({ queryKey: ['ledger'] }),
      ]);
    },
  });
};
